module.exports = __webpack_public_path__ + "static/media/edit_white.a8700bed.svg";